module.exports = __webpack_public_path__ + "static/fleet-16-seat-minibus-sm-73f10b29a5cc1e42978fdf13ee4467d8.jpg";